import { render, staticRenderFns } from "./ReviewStayForms.vue?vue&type=template&id=47d64748"
import script from "./ReviewStayForms.vue?vue&type=script&lang=js"
export * from "./ReviewStayForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports